import React, { useEffect, useState } from 'react';
import * as signalR from "@microsoft/signalr";

const SignalRTest = () => {
    const [status, setStatus] = useState("Desconectado");

    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl("https://localhost:50586/hub/entertainment?uid=testUser&tipo=admin", {
                skipNegotiation: true, // Prueba esto si el error de negociación persiste
                transport: signalR.HttpTransportType.WebSockets
            })
            .build();
        //.withUrl("/hub/entertainment?uid=testUser&tipo=admin")

        connection.on("ReceiveMessage", (message) => {
            console.log("¡Mensaje recibido de SignalR!", message);
            alert("Mensaje recibido: " + message);
        });

        connection.start()
            .then(() => setStatus("¡Conectado exitosamente!"))
            .catch(err => setStatus("Error: " + err.toString()));

        return () => connection.stop();
    }, []);

    return <div>Estado SignalR: {status}</div>;
};

export { SignalRTest };